import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '~/components';
import * as S from './styles';

export default function InfoItem({ value, icon, className }) {
  return (
    <S.Container className={className}>
      <Icon name={icon} size={20} color="white" />
      <S.ValueContainer>
        {value.map(item => {
          return (
            <S.HeaderItemLabel key={item.label}>
              <span>{item.text}</span>
              <br />
              {item.label}
            </S.HeaderItemLabel>
          );
        })}
      </S.ValueContainer>
    </S.Container>
  );
}

InfoItem.propTypes = {
  value: PropTypes.array,
  icon: PropTypes.string,
  className: PropTypes.string,
};

InfoItem.defaultProps = {
  value: {},
  icon: null,
  className: null,
};
